import * as constants from './constants';
import * as slice from './slice';
import sagas from './saga';

const supplierService = { constants, slice, sagas };

export default supplierService;

